import React from 'react';
import { productShortName } from '../data/offer';
export function Footer() {
  return <footer className="bg-industrial text-steel" data-id="element-69" data-mp="3gezdb400vr15">
      <div className="h-1 w-full bg-electric shadow-glow" aria-hidden="true" data-id="element-70" data-mp="3ggtwodvnbb34" />
      <div className="mx-auto max-w-3xl px-4 py-8 text-center" data-id="element-71" data-mp="32ovuyo49khgz">
        <p className="text-xs" data-id="element-72" data-mp="36p6dt1d5n2d9">© 2026 {productShortName} — All rights reserved.</p>
      </div>
    </footer>;
}